export default "__VITE_ASSET__CG5kPgqU__"